module.exports = __webpack_public_path__ + "static/media/bg1.3ed79c5a.png";